<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
// import browserUtils from './util/browserUtils'
export default {
  name: 'App',
  computed: mapState({
    customizeInfo: state => state.customize.info
  }),
  methods: {
    ...mapActions(['setCustomizeInfo']),
    // TODO 主题色等基础信息在此处设置
    loadCustomizeInfo () {
      this.setCustomizeInfo(
        {
          color: '#4FAD6F',
          copyright: '',
          websiteFilingWord: '',
          domainFilingWord: '',
          websiteFilingLink: '',
          domainFilingLink: ''
        }
      )
    }
  },
  mounted () {
    // if (this.isHomePageUrl() && browserUtils.isMobile()) {
    //   window.location.href = this.$contextPath('/static/app/wechat/')
    // } else {
    this.loadCustomizeInfo()
    // }
  }
}
</script>

<style lang="scss">
/* 引入样式 */
@import "styles/index";

#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue